<mat-icon *ngIf="config.icon" class="icon" [style.color]="iconColor">
  {{ config.icon }}
</mat-icon>

<div class="message">{{ config.message }}</div>
